import { ReactElement } from 'react';

import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import FilterService from '@philips-emr/hpms-stipulator-commons/lib/services/filter-service';
import { FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnBeforeFetch, OnDynamicContentRender, OnMount, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { ConsultaAlteracaoSubestipulanteAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';
import { getLoteStampBySituacao, LoteSituacao } from './lote/lote-utils';

interface Data {
  dsSituacao: string;
  ieSituacao: any;
}

@Controller({ fragment: FragmentNames.CONSULTA_ALTERACAO_SUBESTIPULANTE })
export default class ConsultarAlteracaoSubestipulanteController extends BaseController {

  @OnMount(Aliases.FILTER_CONSULTA)
  onFilterMount(event: MountEvent): void {
    FilterService.restoreFilterState(event);
  }

  @OnUnmount(Aliases.FILTER_CONSULTA)
  onUnmountFilter(event: MountEvent): void {
    FilterService.persistFilterState(event);
  }

  @OnDynamicContentRender('hpms-custom-card')
  onDynamicContentRenderCardLote(event: RenderEvent): void {
    const { data, render } = event;
    const { dsSituacao } = data as Data;
    let { ieSituacao } = data as Data;

    switch (ieSituacao) {
      case 1:
        ieSituacao = LoteSituacao.INTEGRADO_A_PROPOSTA;
        break;
      case 2:
        ieSituacao = LoteSituacao.REJEITADA_PELA_OPERADORA;
        break;
      case 3:
        ieSituacao = LoteSituacao.AGUARDANDO_ACAO_DO_USUARIO;
        break;

    }
    const content = (): ReactElement => (getLoteStampBySituacao(ieSituacao, dsSituacao));

    render(content);
  }

  @OnBeforeFetch('fetch-consulta')
  onBeforeFetchBeneficiarios(event: MountEvent): void {
    const fetch = event.target as unknown as FetchAPI;
    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && fetch.setParameters({ ...fetch.getParameters(), nrSeqSubestipulante });
  }

}
